import React, { useState } from 'react';
import { Modal } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import TalentPool from "../../../models/TalentPool";

const DEFAULT_POOL_DATA = { name: '', description: '' };

const CreateUpdateTalentPoolModal = ({ pool = {}, ...props }) => {

    const queryClient = useQueryClient();
    const { auth } = useAuth();
    const navigate = useNavigate();

    const [formModel, setFormModel] = useState({ ...DEFAULT_POOL_DATA, ...pool });
    const createTalentPoolMutation = useMutation(
        ['createTalentPoolMutation'],
        data => TalentPool.createTalentPool(data),
        {
            onSuccess: async () => {
                TB.toast("Talent Pool Created", { type: 'success' });
            },
            onError: () => {
                TB.showServerErrorToast();
            }
        }
    )

    const updateTalentPoolMutation = useMutation(
        ['updateTalentPoolMutation'],
        updateParams => TalentPool.updateTalentPool(updateParams.id, updateParams),
        {
            onSuccess: async () => {
                TB.toast("Talent Pool Updated", { type: 'success' });
            },
            onError: () => {
                TB.showServerErrorToast();
            }
        }
    )

    const onCreateUpdateTalentPool = async () => {
        if (!formModel.name.trim() || !formModel.description.trim()) {
            return TB.alert('error', 'Incomplete Form', 'Please enter both a talent pool name and description');
        }

        if (!pool?.isWrippleRecommendedPool?.() && TalentPool.restrictedPoolNames.includes(TB.toLower(TB.trim(formModel.name)))) {
            return TB.alert('error', 'Name Not Available', 'Sorry, that name is reserved for one of our platform pools. Please try a different pool name');
        }

        let createdTalentPool;

        if (formModel.id) {
            // edit
            createdTalentPool = await updateTalentPoolMutation.mutateAsync(formModel);
        } else {
            // create new
            createdTalentPool = await createTalentPoolMutation.mutateAsync(formModel);
        }

        if (createdTalentPool.id) {
            // only setQueryData if new pool added (not edited)
            await queryClient.setQueryData(['fetchTalentPools', {clientId: auth.clientOrg?.()?.id}], prevData => {
                console.log('prev', prevData)
                if (!prevData) {
                    return prevData
                }
                if (!formModel.id) {
                    const allPools = [...prevData, createdTalentPool];
                    allPools.sort((a, b) => a.name.localeCompare(b.name));
                    return allPools;
                }
                return prevData.map(item => {
                    if (item.id === createdTalentPool.id) {
                        return createdTalentPool;
                    }
                    return item;
                });
            });

        }
        if (!pool.id) {
            navigate(`/client/talent-pool/${createdTalentPool.id}/add-talent`)
        }

        props.onClose();
    }
    return (
        <Modal
            destroyOnClose
            open={true}
            onCancel={() => props.onClose()}
            closable={false}
            maskClosable
            title={null}
            footer={null}
            bodyStyle={{ padding: 0 }}
            className="w-[460px]"
            zIndex={100}
        >
            <div className="bg-white">
                {/* <div className="h-14 bg-primary flex justify-end items-center pl-4">
                    <button
                        type="button"
                        onClick={() => props.onClose()}
                        className="h-[22px] text-white"
                    >
                        <div className="close-icon" />
                    </button>
                </div> */}

                <div className="px-8 py-6 flex flex-col gap-4">

                    <div className="flex justify-between gap-4">
                        <p className="text-xl font-semibold">{formModel.id ? 'Edit' : 'Create'} Talent Pool</p>

                        <button
                            type="button"
                            onClick={() => props.onClose()}
                            className="h-[22px]"
                        >
                            <div className="close-icon" />
                        </button>
                    </div>

                    <div className="">
                        <div className="flex flex-col gap-3">
                            <label htmlFor="name">
                                <span className="block">Name</span>
                                <input
                                    autoFocus={!pool?.isWrippleRecommendedPool?.()}
                                    disabled={pool?.isWrippleRecommendedPool?.()}
                                    // ref={inputRef}
                                    type="text"
                                    id="name"
                                    placeholder="Name Your Talent Pool"
                                    value={formModel.name}
                                    onChange={e => setFormModel({ ...formModel, name: e.target.value })}
                                    className="w-full border border-gray-400 p-2 placeholder:text-gray-400"
                                />
                            </label>

                            <label htmlFor="description">
                                <span className="block">Description</span>
                                <textarea
                                    name="description"
                                    id="description"
                                    placeholder="Use this space to add a description to your new Talent Pool. Include anything you think others in your organization should know. Be sure not to leave out any guidelines for Talent selection."
                                    value={formModel.description}
                                    onChange={e => setFormModel({ ...formModel, description: e.target.value })}
                                    className="w-full border border-gray-400 p-2 placeholder:text-gray-400"
                                    rows={6}
                                />
                            </label>

                            <div className="flex gap-6">
                                <button
                                    type="button"
                                    onClick={() => {
                                        props.onClose();
                                    }}
                                    className="btn w-full p-3"
                                    disabled={createTalentPoolMutation?.isLoading || updateTalentPoolMutation?.isLoading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        console.log(formModel)
                                        return onCreateUpdateTalentPool({ ...formModel })

                                    }}
                                    disabled={createTalentPoolMutation?.isLoading || updateTalentPoolMutation?.isLoading}
                                    className="btn bg-secondary text-white w-full p-3"
                                >
                                    Finish & Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Modal>
    )
};

export default CreateUpdateTalentPoolModal;